// Task #3035 — prod read-only preview banner.
//
// Mounted unconditionally in App.tsx; renders nothing unless the bundle
// was built with `VITE_APP_DB_MODE=prod-readonly`. The env var is read
// at build time so a normal production bundle can never accidentally
// render this banner.

import { useAppTranslation } from "@/i18n/useAppTranslation";

export function ProdReadonlyBanner() {
  const { t } = useAppTranslation();
  if (import.meta.env.VITE_APP_DB_MODE !== "prod-readonly") return null;
  return (
    <div
      role="alert"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        width: "100%",
        background: "#b91c1c",
        color: "#ffffff",
        padding: "8px 12px",
        textAlign: "center",
        fontWeight: 700,
        fontSize: "14px",
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        borderBottom: "2px solid #7f1d1d",
        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
      }}
    >
      {t("common.prod_readonly_banner")}
    </div>
  );
}
